const __request = require(`../__request/__request_contentType_json`);

// 国内退票日志
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/buyer/dom/manage/refundLog',
    data:data
  }

  return __request(pParameter)
}

